import { Injectable } from '@angular/core';
import { FileResult } from '@imagise/entities';
import { EditorAnimationDraftOperation } from './editor-domain.models';

export interface AnimationSession {
  imageFile: FileResult;
  draft: EditorAnimationDraftOperation;
}

/**
 * Keeps the last Animation Maker session alive across editor instances.
 *
 * The editor (and its EditorFormStore) is recreated on every tool-page
 * navigation, which would otherwise drop all collected animation frames.
 * The editor saves its animation state here on destroy and restores it
 * when the user returns to the animation tool.
 */
@Injectable({ providedIn: 'root' })
export class AnimationSessionService {
  private session: AnimationSession | null = null;

  save(session: AnimationSession): void {
    this.session = session;
  }

  restore(): AnimationSession | null {
    return this.session;
  }

  clear(): void {
    this.session = null;
  }
}
